import React, { FC, ReactNode, useEffect, useState } from 'react';
import { FormControl, FormErrorMessage, FormLabel, Input, InputGroup, Textarea } from '@chakra-ui/react';

type TextFieldProps = {
  id: string;
  label: string;
  value?: number;
  helperText?: string;
  error?: boolean;
  required?: boolean;
  multiline?: boolean;
  disabled?: boolean;
  rows?: number;
  onChange?: (value: number) => void;
};

const NumberField: FC<TextFieldProps> = (props) => {
  const { 
    id,
    label,
    value,
    helperText,
    error,
    required,
    multiline,
    disabled, 
    onChange, 
  } = props;

  const [insideValue, setInsideValue] = useState<string>('');

  const onChangeHandler = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    if (!event.target.value) {
      setInsideValue('');
      onChange?.(0);
      return;
    }
    if (!/^[+-]?[0-9]+[.,]?[0-9]*$/g.test(event.target.value)) {
      return;
    }
    setInsideValue(event.target.value);
    const newValue = Number(event.target.value.replace(',', '.'));
    onChange?.(newValue);
  };

  useEffect(() => {
    setInsideValue((_insideValue) =>
      Number(_insideValue) === value ? _insideValue : (value ?? '').toString()
    );
  }, [value]);

  return (<InputGroup>
    <FormControl 
      variant="floating" 
      id={id} 
      isRequired={required}
      isInvalid={error}
      isDisabled={disabled}
    >
      {/* {leftIcon && <InputLeftElement pointerEvents='none'>
        <Icon as={leftIcon} color='brand.300' />
      </InputLeftElement>}
      {rightElement && <InputRightElement>
        {rightElement}
      </InputRightElement>} */}
      {!multiline && <Input 
        placeholder={label}
        value={insideValue}
        onChange={onChangeHandler}
      />}
      {multiline && <Textarea
        value={insideValue}
        onChange={onChangeHandler}
        placeholder={label}
        size='sm'
      />}
      <FormLabel textColor="dark.300">{label}</FormLabel>
      {error && <FormErrorMessage>{helperText}</FormErrorMessage>}
    </FormControl>
  </InputGroup>);
};

export default NumberField;
